export default [
    {
        path: '/',
        name: 'RetroHome',
        component: () => import(/* webpackChunkName: "retro-home" */ './views/Home.vue'),
    },
    {
        path: '/boards/:id',
        name: 'RetroBoard',
        component: () => import(/* webpackChunkName: "retro-board" */ './views/Board.vue'),
    },
    {
        path: '*',
        redirect: '/',
    },
]
